export default __webpack_public_path__ + "static/media/promo-spotlight.70a046b0.png";